import { ITradesGasData, ITradesGasHistoryData } from "./gasData.types"
import { Dayjs } from "dayjs"

export class TradesGasData implements ITradesGasData {
  constructor(
    public id: number,
    public date: Dayjs | null,
    public period: string | null,
    public index: string | null,
    public price: number | null,
    public volume: number | null,
    public totalVolume: number,
    public dateFrom: Dayjs | null,
    public dateTo: Dayjs | null,
    public counterParty: string | null,
    public trader: string | null,
    public notes: string | null,
    public confirmReceivedDate: Dayjs | null,
    public confirmSignedDate: Dayjs | null,
    public confirmSignedBy: string | null,
    public locked: boolean,
  ) {}
}

export class TradesGasHistoryData implements ITradesGasHistoryData {
  constructor(
    public id: number,
    public gasTradeId: number,
    public date: Dayjs | null,
    public period: string | null,
    public index: string | null,
    public price: number | null,
    public volume: number | null,
    public totalVolume: number,
    public dateFrom: Dayjs | null,
    public dateTo: Dayjs | null,
    public counterParty: string | null,
    public trader: string | null,
    public notes: string | null,
    public confirmReceivedDate: Dayjs | null,
    public confirmSignedDate: Dayjs | null,
    public confirmSignedBy: string | null,
  ) {}
}
